import { JsDateRange, now } from "common";
import React, { useState } from "react";
import shallow from "zustand/shallow";
import { getInitialDate } from "../../../../models/Reports";
import { usePartnerCommissionsFilterStore } from "../../../../stores/reports/partnerCommissionsFilterStore";
import { ReportDatePicker } from "../../ReportDatePicker";

export const PartnerStatementFilter = () => {
    const [from, to] = usePartnerCommissionsFilterStore((state) => [state.getFrom(), state.getTo()], shallow);
    const [setFrom, setTo] = usePartnerCommissionsFilterStore((state) => [state.setFrom, state.setTo], shallow);

    const [value, setValue] = useState(getInitialDate(from, to));
    const handleDateChange = (dateValue: JsDateRange) => {
        if (dateValue.from && dateValue.to) {
            setFrom(now(dateValue.from));
            setTo(now(dateValue.to));
        }

        setValue(dateValue);
    };

    return (
        <div className="flex flex-row items-center justify-between border-b border-gray-light px-6 py-3 print:hidden">
            <div className="flex w-full flex-row items-center justify-between">
                <div className="flex w-full flex-row items-center justify-start space-x-1 xl:space-x-4">
                    <div>
                        <ReportDatePicker from={from} to={to} value={value} onChange={handleDateChange} />
                    </div>
                </div>
            </div>
        </div>
    );
};
